/* eslint-disable import/extensions,import/no-unresolved,import/no-duplicates,import/no-named-as-default-member */

import { createSelector } from 'reselect';
import { mapWithDefault } from 'utils/dataMapper';

const selectGlobal = (state) => state.get('global');

const makeSelectPolicyId = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('selectedPolicyId'), '')
  );

const makeSelectClientId = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('clientId'), '')
  );

const makeSelectShowElectronicConsentDocument = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('showElectronicConsentDocument'), false)
  );

const makeSelectShowRequiredDocument = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('showRequiredDocument'), false)
  );

const makeSelectShowZurichUHC = () =>
    createSelector(selectGlobal, (state) =>
      mapWithDefault(state, () => state.get('showZurichUHC'), false)
    );

const makeSelectIsClaimGroupAllowed = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('isClaimGroupAllowed'), false)
  );

const makeSelectIsPolicyCancelled = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('isPolicyCancelled'), false)
  );

const makeSelectIsClaimForFieldEnabled = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('isClaimForFieldEnabled'), false)
  );

const makeSelectCellCaptiveCountryId = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('cellCaptiveCountryId'), false)
  );

const makeSelectPolicyTypeCode = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('policyTypeCode'), '')
  );

const makeSelectEmailAddressLogin = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('emailAddressLogin'), '')
  );

const makeSelectPhoneNumberLogin = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('phoneNumberLogin'), '')
  );

const makeSelectDeclarationClaimsAdminCompanyName = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('FNOLDeclarationClaimsAdminCompanyName'), '')
  );

const makeSelectTPAName = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('TPAName'), '')
  );

const makeSelectCarrier = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('Carrier'), '')
  );

const makeSelectClaimantId = () =>
    createSelector(selectGlobal, (state) =>
      mapWithDefault(state, () => state.get('claimantId'), '')
    );

const makeSelectLoading = () =>
  createSelector(selectGlobal, (globalState) => globalState.get('loading'));

const makeSelectError = () =>
  createSelector(selectGlobal, (globalState) => globalState.get('error'));

const makeSelectRepos = () =>
  createSelector(selectGlobal, (globalState) =>
    globalState.getIn(['userData', 'repositories'])
  );

const makeSelectIsAuthenticated = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('isAuthenticated')
);
const makeSelectFnolReportDateValidation = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('fnolReportDateValidation')
);

const makeSelectValidateStep = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('validateStep')
);

const makeSelectMedicalAuthorityFormLink = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('medicalAuthorityFormLink')
);
const makeSelectMedicalCertificateFormLink = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('medicalCertificateFormLink')
);

const makeSelectAppClaimType = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('appClaimTypes').toJS()
);

const makeSelectAppChildBenefit = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('appChildBenefits').toJS()
);

const makeSelectValidationDateErrorMessage = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('policyValidationDateErrorMessage')
);

const makeSelectJSONVersion = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('jsonVersion')
);


const makeSelectInsuredsList = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('insuredList')
);

const makeSelectClaimPaymentVersion = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('claimPaymentVersion')
);

const makeSelectIsLinkedCover = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('isLinkedCover')
);

const makeSelectIncidentDate = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('incidentDate')
);

const makeSelectPolicyPurchaseDate = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('policyPurchaseDate')
);

const makeSelectPolicyEffectiveDate = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('policyEffectiveDate')
);

const makeSelectPolicyTerminationDate = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get('policyTerminationDate')
);

const makeSelectInitClaimTypeList = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get(('initClaimTypeList'), []),
);

const makeSelectSpecifiedItems = () => createSelector(
  selectGlobal,
  (globalState) => globalState.get(('specifiedItems'), []),
);

const makeSelectShowTrawickFNOLRefactoring = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('showTrawickFNOLRefactoring'), false)
  );

const makeSelectShowTrawickPaymentScreen = () =>
  createSelector(selectGlobal, (state) =>
    mapWithDefault(state, () => state.get('showTrawickPaymentScreen'), false)
  );
export {
  selectGlobal,
  makeSelectPolicyId,
  makeSelectLoading,
  makeSelectError,
  makeSelectRepos,
  makeSelectIsAuthenticated,
  makeSelectFnolReportDateValidation,
  makeSelectValidateStep,
  // makeSelectfInceptionDate,
  // makeSelectfExpDate,
  makeSelectMedicalAuthorityFormLink,
  makeSelectMedicalCertificateFormLink,
  makeSelectAppClaimType,
  makeSelectAppChildBenefit,
  makeSelectValidationDateErrorMessage,
  makeSelectJSONVersion,
  makeSelectInsuredsList,
  makeSelectClaimPaymentVersion,
  makeSelectIsLinkedCover,
  makeSelectIncidentDate,
  makeSelectShowElectronicConsentDocument,
  makeSelectDeclarationClaimsAdminCompanyName,
  makeSelectEmailAddressLogin,
  makeSelectClientId,
  makeSelectTPAName,
  makeSelectCarrier,
  makeSelectShowRequiredDocument,
  makeSelectIsClaimGroupAllowed,
  makeSelectIsPolicyCancelled,
  makeSelectCellCaptiveCountryId,
  makeSelectInitClaimTypeList,
  makeSelectPhoneNumberLogin,
  makeSelectShowZurichUHC,
  makeSelectPolicyPurchaseDate,
  makeSelectPolicyEffectiveDate,
  makeSelectPolicyTerminationDate,
  makeSelectClaimantId,
  makeSelectIsClaimForFieldEnabled,
  makeSelectPolicyTypeCode,
  makeSelectSpecifiedItems,
  makeSelectShowTrawickFNOLRefactoring,
  makeSelectShowTrawickPaymentScreen,
};



// WEBPACK FOOTER //
// ./app/containers/App/selectors.js